export default __webpack_public_path__ + "static/media/DAIF_UseCase_Screen3_in.aa28a312.mp4";